<template>
  <div>
    <div class="fw-bold"><i class="fa-solid fa-file me-2"/>リクエストがキャンセルされました。</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'request-canceled',
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapState(['notice']),
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss" module="s">
.datetime {
  padding: 2px 6px;
  border: 1px solid var(--primary-blue);
  color: var(--primary-blue);
  display: inline-block;
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 8px;
}
</style>
